import { render } from "./jieti-form.vue?vue&type=template&id=1d6361be&scoped=true"
import script from "./jieti-form.vue?vue&type=script&lang=js"
export * from "./jieti-form.vue?vue&type=script&lang=js"

import "./jieti-form.vue?vue&type=style&index=0&id=1d6361be&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6361be"]])

export default __exports__